export const defaultBackgroundImageUrls = [
  "architecture-5082700_1280",
  "porch-691330_1280",
  "saxon-switzerland-539418_1280",
  "shibuyasky-4768679_1280",
].map((imageName) => `https://cdn.cometchat.io/calls/v3/bg/${imageName}.jpg`);
